/* eslint-disable max-len */
// ---- Akadian "Need Help?" Button → Opens Student Success Guide ----
// Marketplace-safe styling, fixed position, dark-mode ready
(function () {
  if (window.__akHelpInjected) return;
  window.__akHelpInjected = true;
  // ==============================
  // CONFIG
  // ==============================
  var STUDENT_SUCCESS_URL = "https://akadian.com/support"; // :white_check_mark: Final URL
  // ==============================
  // STYLES
  // ==============================
  var css = `
  #ak-help-root .ak-help-btn {
    display:inline-flex;
    align-items:center;
    gap:.6rem;
    padding:.9rem 1.4rem;
    border:0 !important;
    border-radius:10px;
    background:#F57A47 !important;
    background-color:#F57A47 !important;
    color:#fff !important;
    box-shadow:0 8px 20px rgba(0,0,0,.18);
    font:700 18px/1.3 system-ui,-apple-system,Segoe UI,Roboto;
    position:fixed;
    right:20px;
    bottom:20px;
    z-index:9998;
    cursor:pointer;
    transition: background-color .2s ease, transform .2s ease;
    appearance:none;
    -webkit-appearance:none;
    background-image:none !important;
    text-transform:none !important;
  }
  #ak-help-root .ak-help-btn:hover {
    background:#e46933 !important;
    background-color:#e46933 !important;
    color:#fff !important;
    transform: scale(1.05);
  }
  #ak-help-root .ak-help-icon {
    width:22px; height:22px; display:inline-block;
  }
  /* -------- Dark Mode (auto + class-based hooks) -------- */
  @media (prefers-color-scheme: dark) {
    #ak-help-root .ak-help-btn {
      box-shadow:0 8px 20px rgba(0,0,0,.5);
    }
  }
  html.dark #ak-help-root .ak-help-btn,
  body.dark #ak-help-root .ak-help-btn,
  [data-theme="dark"] #ak-help-root .ak-help-btn {
    box-shadow:0 8px 20px rgba(0,0,0,.5);
  }
  `;
  var style = document.createElement("style");
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
  // ==============================
  // HTML
  // ==============================
  var root = document.createElement("div");
  root.id = "ak-help-root";
  root.innerHTML = `
    <button id="needHelpBtn" type="button" class="ak-help-btn" aria-label="Open Student Success Guide">
      <svg class="ak-help-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20 3H4a2 2 0 0 0-2 2v11.5A2.5 2.5 0 0 0 4.5 19H6v2.5a.5.5 0 0 0 .8.4L10.5 19H20a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Z"/>
        <path d="M12 7a3 3 0 0 0-3 3h2a1 1 0 1 1 2 0c0 .6-.3.9-1.1 1.4-.9.6-1.9 1.2-1.9 2.6V15h2v-.1c0-.6.4-.9 1.2-1.4.9-.6 1.8-1.3 1.8-2.6A3 3 0 0 0 12 7Zm0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"/>
      </svg>
      <span>Need Help?</span>
    </button>
  `;
  (document.body || document.documentElement).appendChild(root);
  // ==============================
  // BEHAVIOR
  // ==============================
  var openBtn = root.querySelector("#needHelpBtn");
  openBtn.addEventListener("click", function (e) {
    e.preventDefault();
    window.open(STUDENT_SUCCESS_URL, "_blank", "noopener,noreferrer");
  });
})();
